import React, { useEffect } from "react";

const NotFoundPage = () => {
  // const location = useLocation()
  useEffect(() => {
    // location.replace("/notfound");
  }, []);
  return (
    <>
      <div>
        <h2>404 - Not Found</h2>
        <p>The page you are looking for does not exist.</p>
      </div>
    </>
  );
};

export default NotFoundPage;
